import { flow } from "fp-ts/lib/function";

import { formatSignedPctNumber } from "../../lens-stats/formatters";
import { getInsightsDiffPct, safeDivide } from "../math";
import { type InsightsMetrics, type LensCTRPair, type StatsItem } from "../models";

const safeDivideLensCTRPairs = ([a, b]: [LensCTRPair, LensCTRPair]): [number, number] => [
    safeDivide(a.swipeUps, a.lensPlays),
    safeDivide(b.swipeUps, b.lensPlays),
];

const getCurrPrevInsightsDiffPct = ([curr, prev]: [number, number]) => getInsightsDiffPct(curr, prev);

export const mapCTRDiffValue =
    (lensCTRPairs: [LensCTRPair, LensCTRPair], isLifetime: boolean) =>
    (computedMetric: InsightsMetrics<StatsItem>): InsightsMetrics<StatsItem> => {
        if (isLifetime) {
            return computedMetric;
        }

        const diffValue = flow(safeDivideLensCTRPairs, getCurrPrevInsightsDiffPct, formatSignedPctNumber)(lensCTRPairs);

        return {
            ...computedMetric,
            diffValue,
        };
    };
